import React, {useContext} from "react";
import QRCode from "qrcode.react";
import {Theme} from "engage-client/theme";
import {createUseStyles, useTheme} from "react-jss";
import {EngageAppContext} from "../../App";
import Welcome from "engage-client/components/Welcome";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import useMediaQuery from "engage-client/hooks/useMediaQuery";
import {useWindowSize} from "engage-client/hooks/useResizeObserver";

const QRCodeSize = 245;

const useStyles = createUseStyles<Theme>((theme) => ({
	join: {
		height:"100%",
		padding: [0,16],
		position: "relative",
		display:"flex",
		flexDirection:"column",
		justifyContent: "center",
		alignItems: "center",
		textAlign: "center",
	},
	qrCodeContainer: {
		display:"flex",
		justifyContent: "center",
		alignItems:"center",
		backgroundColor:"white",
		padding: 30,
		borderRadius: 30,
		margin: "50px 0",
		[theme.breakpoints.up("xxl")] : {
			marginTop: "4vh",
			marginBottom: "4vh",
			padding: "3vh",
			borderRadius: 40
		},
	},
	urlBox: {
		margin: "16px 0 0",
		border: "1px solid #FFFFFF",
		padding: "20px 70px",
		[theme.breakpoints.up("xxl")] : {
			marginTop: "1vw"
		},
	},
}));

export default function JoinInstructions() {
	const {lobby} = useContext(EngageAppContext.current);
	const windowHeight = useWindowSize().height;
	let xlQRCodeSize = -1;
	if (windowHeight) {
		xlQRCodeSize= (22 * windowHeight) / 100;
	}
	const classes = useStyles();
	const theme:Theme = useTheme();
	const isXXL = useMediaQuery(theme.breakpoints.up("xxl"));
	const url = window ? `${window.location.origin}/j/${lobby?.id}` : "https://si.sas.com";
	return (
		<div className={classes.join}>
			<Welcome title={lobby?.title ?? "Trivia Game"}/>
			<div className={classes.qrCodeContainer}>
				<QRCode value={url} size={isXXL ? xlQRCodeSize : QRCodeSize}/>
			</div>
			<div>
				<DisplayText variant={TextVariant.s28reg} color="white">Scan or enter the URL below.</DisplayText>
				<DisplayText variant={TextVariant.s40black} className={classes.urlBox} color="white">{url}</DisplayText>
			</div>
		</div>
	);
};
